const Constants = {

    SET_ME: "SET_ME",
    SET_TEST: "SET_TEST"

};

export default Constants;